import { useToasts } from "react-toast-notifications";
import service from "../../../api/services";
import { useNavigate } from "react-router";
import { useState } from "react";

export const useLogic = () => {
    const { addToast } = useToasts();
    const navigate = useNavigate()
    const token = localStorage.getItem("access_token")
    const [toggleDropdown, setToggleDropdown] = useState(false)


    const logout = async () => {
        try {
            let response = await service.auth.logout(token)
            if (response.status === 200) {
                addToast(response?.data?.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
                localStorage.setItem("access_token", '')
                localStorage.setItem("username", '')
                localStorage.setItem("store_name", '')

                navigate("/login");
            }
        } catch (error: any) {
            console.error(error)
            addToast(error?.response?.data?.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }
    return {
        logout,
        setToggleDropdown,
        toggleDropdown
    }
}